import type { FormProps } from 'antd';

/** Тип словаря берётся у самой формы: пакет `@rc-component/form` — транзитивный, его не импортируем. */
type ValidateMessages = NonNullable<FormProps['validateMessages']>;

/**
 * Тексты отказа для полей, у которых своего текста нет.
 *
 * Свой текст всегда лучше общего: «Выберите объект» говорит, что делать, а «Поле обязательно к
 * заполнению» — только что не так. Поэтому словарь не заменяет `message` у правил, а подставляется
 * там, где его не написали: иначе поле молчит по-английски (`ru_RU` даёт «Пожалуйста, введите …»
 * с техническим именем вместо подписи).
 *
 * Подставляется один раз на портал через `ConfigProvider form={{ validateMessages }}`.
 */
export const FORM_VALIDATE_MESSAGES: ValidateMessages = {
  default: 'Поле заполнено неверно',
  required: 'Поле обязательно к заполнению',
  // Пробелы вместо значения — то же самое, что пусто: правило `whitespace` стоит там, где текст
  // уходит в документ или в историю заявки.
  whitespace: 'Поле обязательно к заполнению',
  types: {
    number: 'Поле заполняется только цифрами',
    email: 'Введите корректный email',
    url: 'Введите корректную ссылку',
  },
  string: {
    max: 'Не длиннее ${max} символов',
    min: 'Не короче ${min} символов',
  },
  number: {
    max: 'Не больше ${max}',
    min: 'Не меньше ${min}',
  },
};
